






































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import vSelect from "vue-select";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import { getContract, createContract, updateContract } from "@/services/contracts/contractService";
import { getInstances } from "@/services/instances/instanceService";
import { Contract, Licences } from "@/services/contracts/types";

@Component<ContractForm>({
    components: {
        HeaderActionButtons,
        vSelect
    }
})
export default class ContractForm extends Vue {
    @Prop() private contractId!: string;

    // local state
    contract = {
        id: "",
        instanceName: "",
        name: "",
        number: "",
        licences: {
            information: 0,
            guestRegistration: 0,
            meet: 0,
            wall: 0,
            poster: 0,
            sessions: 0,
            calmviso: 0
        } as Licences
    } as Contract;

    instances: any = [];

    // computed
    get editMode() {
        return !!this.contractId;
    }

    // hooks
    beforeMount() {
        this.fetchData();
    }

    // methods
    fetchData() {
        if (this.editMode) {
            getContract(this.contractId).then(response => {
                this.contract = response;
                this.contract.number = this.contract.number.slice(2);
            });
        }
        getInstances().then(response => {
            this.instances = response.map(x => ({
                id: x.id,
                name: x.name
            }));
        });
    }

    save() {
        this.contract.number = `C-${this.contract.number}`;
        if (this.editMode) {
            updateContract(this.contract).then(() => {
                this.$router.push("/contracts");
            });
        } else {
            createContract(this.contract).then(() => {
                this.$router.push("/contracts");
            });
        }
    }

    back() {
        this.$router.push("/contracts");
    }

    contractNumberFormatter(value: string) {
        return value.substring(0, 6);
    }
}
